"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const PublicDomainToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { title: 'Public Domain', info: 'When a registered work is categorized as a public domain work, the registration is marked as public domain in The MLC database. Royalties are not allocated or paid to identified public domain works unless the work is registered as a unique arrangement.', place: 'top' }));
exports.default = PublicDomainToolTip;
